export function isExpired(jobAdvertExpiryDate) {
    var expiryDate = new Date(jobAdvertExpiryDate).getTime();
    var currentDate = new Date().getTime();
    return expiryDate < currentDate;
}

export const decodeShortDescription = (html) => {
  var txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};
  